<template>
  <RouterView />
</template>

<script setup lang="ts">
import '@/assets/styles/global.scss'
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

#launcher {
  display: none;
}
</style>
